/**
 * Brands Slider with Alphabet Navigation
 */

import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

document.addEventListener("DOMContentLoaded", function () {
	const brandsSlider = document.querySelector(".brands-swiper");

	if (!brandsSlider) return;

	// Initialize Swiper
	const swiper = new Swiper(".brands-swiper", {
		modules: [Navigation, Autoplay],
		slidesPerView: 3,
		spaceBetween: 30,
		loop: true,
		autoplay: {
			delay: 2000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},
		navigation: {
			nextEl: ".brands-slider-next",
			prevEl: ".brands-slider-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 4,
			},
			992: {
				slidesPerView: 5,
			},
		},
	});

	// Alphabet navigation
	const alphabetNav = document.querySelector(".alphabet-nav");
	const alphabetLetters = document.querySelectorAll(".alphabet-letter");
	const slides = document.querySelectorAll(".swiper-slide");

	if (!alphabetNav || alphabetLetters.length === 0) return;

	// Function to update active letter based on visible slides
	function updateActiveLetter() {
		const activeSlide = slides[swiper.realIndex];
		if (!activeSlide) return;

		const firstLetter = activeSlide.dataset.letter;

		// Remove active class from all letters
		alphabetLetters.forEach((letter) => letter.classList.remove("active"));

		// Add active class to current letter
		const activeLetter = Array.from(alphabetLetters).find((letter) => letter.dataset.letter === firstLetter);
		if (activeLetter) {
			activeLetter.classList.add("active");
		}
	}

	// Update on slide change
	swiper.on("slideChange", updateActiveLetter);

	// Initial update
	updateActiveLetter();

	// Click on letter to navigate
	alphabetLetters.forEach((letter) => {
		if (letter.classList.contains("disabled")) return;

		letter.addEventListener("click", function (e) {
			e.preventDefault();

			const targetLetter = this.dataset.letter;

			// Find first slide with this letter
			const targetIndex = Array.from(slides).findIndex((slide) => slide.dataset.letter === targetLetter);

			if (targetIndex !== -1) {
				swiper.slideToLoop(targetIndex);
			}
		});
	});
});
